import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';

const CheckboxSwitchField= ({name, placeholder}) => {
  const { control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="form-check form-switch form-switch-md">
          <input
            {...field}
            value={field.value}
            checked={field.value}
            id={field.name}
            type="checkbox"
            className={`form-check-input ${invalid ? "is-invalid" : ""}`}
          />
          { placeholder && <label className="form-check-label py-1 px-2" for={field.name}>{placeholder}</label> }
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}


CheckboxSwitchField.defaultProps = {};

CheckboxSwitchField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
};

export default CheckboxSwitchField;